import React, { useEffect, useMemo, useRef, useState, useContext } from "react";
import "./styles.css";
import { AutoComplete, Breadcrumb, DatePickerInput, SuccessPopupModal, TextInput, Title, } from "../../Components/Atoms";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Button, useToast } from "@chakra-ui/react";
import { getStatesByCountryId, getCitiesByStateID, editDealershipDetails, getAllMakes, getDealerDetails, getSellerDetails, getTermsAndconditionsUrl, editSellerDetails } from "../../APIs";
import PATH from "../../Routes/paths";
import { isValidMobile, isValidEmail, isValidPincode} from "../../Library/validations";
import ROUTES from "../../Routes/paths";
import { LIVE_TRACKING_ACC_CODE, SELLER_DES } from "../../Library/constants";
import { AuthContext, StoreContext } from "../../Library/contexts";
import { getItemFromLocalStorage } from "../../Library/helpers";

const FIELD_TYPE = {
  LABEL: 1,
  TEXT: 2,
  AUTOCOMPLETE: 3,
  DATEPICKER: 4,
};

const INP_KEY_INDEX_MAP = {
  nm: 0, mob: 1, amob: 2, eml: 3, gstno: 4, pin: 5, ct: 6, st: 7, add: 8, dnm: 9, dmob: 10, deml: 11, ddes: 12,
};

const EditDealership = ({ tnc }) => {
  const navigate = useNavigate();
  const { isLiveTrackingEnabled } = useContext(StoreContext);
  const { profile } = useContext(AuthContext);
  const initialState = { nm: "", mob: "", amob: "", eml: "", gstno: "", pin: "", cNm: "", ct: "", sNm: "", st: "", vmk: "", mk: "", add: "", dnm: "", dmob: "", deml: "", ddes: "", ac: [], agTnc: false, };
  const [formData, setFormData] = useState(initialState);
  const [formErrors, setFormErrors] = useState({});
  const [stateOptions, setStateOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [oemOptions, setOemOptions] = useState([]);
  const formRef = useRef("");
  const Toast = useToast();
  const [ searchParams ] = useSearchParams();
  const [editedValues, setEditedValues] = useState({ idx: Number(searchParams.get("idx")) || profile.idx });
  const [dealerDetails, setDealerDetails] = useState({});
  const [tncURl, setTncUrl] = useState("");
  const DESIGNATION = getItemFromLocalStorage("des");
  const [successModalProps, setSuccessModalProps] = useState({});

  useEffect(() => {
    getStatesByCountryId()
      .then((data) => {
        if (data.length) {
          let options = [];
          data.sort((a, b) => a.nm.localeCompare(b.nm));
          data.forEach((state) => {
            if (state.nm && state.idx)
              options.push({ label: state.nm, value: state.idx });
          });
          setStateOptions(options);
        }
      })
      .catch((err) => console.error("EditDealership fetch states failed.", err));

      getAllMakes((err,data)=>{
        if(err){
          console.error("EditDealership fetch oems failed.", err);
        }
        else if (data.length){
          let options = [];
          data.sort((a, b) => a.nm.localeCompare(b.nm));
          data.forEach(oem => {
            if (oem.nm && oem.idx)
              options.push({ label: oem.nm, value: oem.idx });
          });
          setOemOptions(options);
        }
      })
  }, []);

  useEffect(() => {
    let loggedInId = Number(searchParams.get("idx"));
    if (tnc && profile.idx) loggedInId = profile.idx;
    if (loggedInId) {
      let getFunction = getDealerDetails;
      if (DESIGNATION === SELLER_DES && tnc) getFunction = getSellerDetails;

      getFunction(loggedInId, (err, data) => {
        if (err) console.error(err);
        else {
          if (data && data.length) {
            setFormData((prev) => ({...prev, ...data[0], st: data[0].sid, ct: data[0].cid, ac: data[0].accessCodes || [] }));
            setDealerDetails(data[0] || {});
          }
        }
      });

      getTermsAndconditionsUrl((err, data) => {
        if (err) console.error(err);
        else setTncUrl(data.link);
      });
    }
  }, []);

  const fetchCities = (stateId) => {
    if (!stateId) return;
    getCitiesByStateID(stateId)
    .then((data) => {
        if (data.length) {
        let options = [];
        data.sort((a, b) => a.nm.localeCompare(b.nm));
        data.forEach((state) => {
            if (state.nm && state.idx)
            options.push({ label: state.nm, value: state.idx });
        });
        setCityOptions(options);
        }
    })
    .catch((err) => console.error("AddClient fetch states failed.", err));
  }

  const editDealershipFormFields = useMemo(
    () => [
      {
        type: FIELD_TYPE.TEXT,
        label: tnc ? "Company Name" : "Dealership Name",
        name: "nm",
        placeholder: "Enter Dealership Name",
        required: true,
        cls: "add-client-halfw",
      },
      ...(!tnc ? [{
        type: FIELD_TYPE.AUTOCOMPLETE,
        label: "OEM",
        name: "mk",
        placeholder: "Select OEM",
        required: true,
        cls: "add-client-halfw",
        options: oemOptions,
        onChange: (oemId, oemObj) => {
          setFormFieldData('vmk')(oemObj.label);
          setFormFieldData('mk')(oemObj.value);
        }
      }] : []),
      {
        type: FIELD_TYPE.TEXT,
        label: "Mobile Number",
        name: "mob",
        cls: "edit-client-halfw",
        placeholder: "Enter Mobile Number",
        required: true,
        disabled: tnc,
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Alternate  Number",
        name: "amob",
        cls: "edit-client-halfw",
        placeholder: "Enter Alternate Mobile Number",
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Email Address",
        name: "eml",
        placeholder: "Enter Email Address",
        required: true,
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "GST Number",
        name: "gstno",
        placeholder: "Enter GST Number",
      },
      {
        type: FIELD_TYPE.AUTOCOMPLETE,
        label: "State",
        name: "st",
        placeholder: "Select State",
        cls: "edit-client-halfw",
        options: stateOptions,
        onChange: (stateId, stateObj) => {

          if (formData.st === stateId)
            return;
          setFormFieldData('sNm')(stateObj.label);
          setFormFieldData('st')(stateObj.value);
          setFormFieldData('ct')("");
          setFormFieldData('cNm')("");
          getCitiesByStateID(stateId).then((data) => {
            if (data.length) {
              let options = [];
              data.sort((a, b) => a.nm.localeCompare(b.nm));
              data.forEach(state => {
                if (state.nm && state.idx)
                  options.push({ label: state.nm, value: state.idx });
              });
              setCityOptions(options);
            }
          })
            .catch((err) => console.error("Edit Dealer fetch states failed.", err))
        },
        required: true,
      },
      {
        type: FIELD_TYPE.AUTOCOMPLETE,
        label: "City",
        name: "ct",
        placeholder: "Select City",
        cls: "edit-client-halfw",
        options: cityOptions,
        required: true,
        onChange: (_, cityObj) => {
          setFormFieldData('ct')(cityObj.value);
          setFormFieldData('cNm')(cityObj.label);
        },
       },
      {
        type: FIELD_TYPE.TEXT,
        label: "Pincode",
        name: "pin",
        placeholder: "Enter Pincode",
        regex: /^[1-9][0-9]{5}$/,
        cls: "edit-client-halfw",
        required: true,
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Address",
        name: "add",
        placeholder: "Enter Address",
        required: true,
      },
      ...(!tnc ? [{
        type: FIELD_TYPE.CHECKBOX,
        label: "Enable Live Tracking for this dealer",
        name: "ac",
        onChange: (e) => {
          setFormFieldData("ac")(e.target.checked ? [LIVE_TRACKING_ACC_CODE] : []);
        },
      }] : []),
      {
        type: FIELD_TYPE.LABEL,
        label: "Contact Person Details",
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Name",
        name: "dnm",
        placeholder: "Enter Name",
        cls: "edit-client-halfw",
        required: true,
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Mobile Number",
        name: "dmob",
        placeholder: "Enter Mobile Number",
        cls: "edit-client-halfw",
        required: true,
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Email Address",
        name: "deml",
        placeholder: "Enter Email Address",
        required: true,
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Designation",
        name: "ddes",
        placeholder: "Enter Designation",
        required: true,
      },
      ...(tnc ? [{
        type: FIELD_TYPE.CHECKBOX,
        label: <span>I have read and accept the <Link className="tnc-link" to={tncURl} target="_blank">Terms & Conditions</Link></span>,
        name: "agTnc",
        onChange: (e) => {
          setFormFieldData("agTnc")(e.target.checked);
        },
        cls: "tnc-cnt",
      }] : []),
    ],
    [oemOptions, stateOptions, cityOptions, formData.st]
  );

  const setFormFieldData = (key) => (value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
    setEditedValues((prev) => ({ ...prev, [key]: value }));
  };

  const saveDealershipData = (modelData) => {
    let postFunction = editDealershipDetails;
    if (tnc && DESIGNATION === SELLER_DES) postFunction = editSellerDetails;

    postFunction(modelData, (failure, success) => {
      if (failure) {
        const errMsg = JSON.parse(failure).data;
        Toast({
          isClosable: true,
          description: errMsg,
          position: "bottom",
          variant: "subtle",
          duration: 3000,
        });
      } else {
        setFormData(initialState);
        setSuccessModalProps({
          open: true,
          modalSize: "lg",
          modalMsg: tnc ? "Thanks for reviewing and accepting the Terms and Conditions." : "Dealership Edited successfully",
          closeBtn: "Okay",
          onModalClose: () => {
            if (tnc) {
              setSuccessModalProps({});
              navigate("/");
            }
            else navigate(`${ROUTES.SHOW_DEALERS}/${ROUTES.SPECIFIC_DEALER}?idx=${searchParams.get("idx")}`);
          },
        });
      }
    });
  };

  const submitHandler = () => {
    if (tnc && !editedValues.agTnc) return;
    if(Object.keys(editedValues).length === 1){
      Toast({
        isClosable: true,
        description: "No Changes made to save !!",
        position: "bottom",
        variant: "subtle",
        duration: 3000,
      });
      return;
    }

    let errors = {};
    let hasError = false;
    let fieldName = "";

    if (editedValues.mob || editedValues.amob || editedValues.dmob) {
        if (!isValidMobile(editedValues.mob || editedValues.amob || editedValues.dmob)) {
            hasError = true;
            if (!fieldName) fieldName = (editedValues.mob && "mob") || (editedValues.amob && "amob") || (editedValues.dmob && "dmob");
            errors[fieldName] = "Please enter valid mobile";
        }
    }

    if (editedValues.eml || editedValues.deml) {
       if (!isValidEmail(editedValues.eml || editedValues.deml) ) {
            hasError = true;
            if (!fieldName) fieldName = (editedValues.eml && "eml") || (editedValues.deml && "deml");
            errors[fieldName] = "Please enter valid email";
       }
    }

    if(editedValues.state && !editedValues.city){
        hasError = true;
        if (!fieldName) fieldName = "ct";
        errors.city = "Please select city";
    }

    if (editedValues.pin) {
      if (!isValidPincode(editedValues.pin)) {
        hasError = true;
        if (!fieldName) fieldName = "pin";
        errors.pin = "Please enter valid pincode";
      }
    }

    Object.keys(editedValues).forEach((key) => {
    if (key !== "amob" && key !== "gstno") {
      if (!editedValues[key]) {
        hasError = true;
        errors[key] = "This field is required";
        if (!fieldName) fieldName = key;
      }
    } else {
      const isFieldInitiallyPresent = dealerDetails[key];
      const isFieldEmpty = editedValues[key] === "";
      if (isFieldInitiallyPresent && isFieldEmpty) {
        hasError = true;
        errors[key] = "This field cannot be left blank";
        if (!fieldName) fieldName = key;
      } else if (!isFieldInitiallyPresent && isFieldEmpty) {
        delete editedValues[key];
      }
    }
    });

    if (tnc && (editedValues.st || editedValues.ct)) {
      if (editedValues.st) {
        editedValues.sid = editedValues.st;
        delete editedValues.st;
        delete editedValues.sNm;
      }
      editedValues.cid = editedValues.ct;
      delete editedValues.ct;
      delete editedValues.cNm;
    }

    if (hasError) {
      setFormErrors(errors);
      if (fieldName && formRef.current) formRef.current[INP_KEY_INDEX_MAP[fieldName]].scrollIntoView({ behavior: "smooth", block: "center" });
    }
    else if (Object.values(editedValues).length > 1) saveDealershipData(editedValues);
  };

  const dealerShipBreadcrumbPaths = [
    { idx: 1, name: "Dealership Details", link: `${PATH.SHOW_DEALERS}/${PATH.SPECIFIC_DEALER}?idx=${dealerDetails.idx}` },
    { idx: 2, name: "Edit Dealership", link: "", isCurrentPage: true },
  ];

  const handleFetchCities = (name) => {
    if (!cityOptions.length) fetchCities(formData[name]);
    return formData[name];
  }

  return (
    <section className="panel-main">
      {!tnc ? <div>
        <Breadcrumb paths={dealerShipBreadcrumbPaths} />
      </div> : null}

      <div className="edit-client">
        <Title>{tnc ? "Company & Decision Maker Details" : "Edit Dealership"}</Title>
        <form className="edit-client-form" ref={formRef}>
          {editDealershipFormFields.map((formField, idx) => {
            if (!isLiveTrackingEnabled && formField.name === "ac") return <></>;
            return (
              <div
                key={idx}
                className={formField.cls ? formField.cls : "edit-client-fullw"}
              >
                {formField.type === FIELD_TYPE.LABEL && (
                  <p key={idx} className="edit-client-subheadings">
                    {formField.label || ""}
                  </p>
                )}
                {formField.type === FIELD_TYPE.TEXT && (
                  <TextInput
                    inputName={formField.name || ""}
                    placeholder={formField.placeholder}
                    className="edit-client-text-field"
                    label={formField.label}
                    labelClassName="edit-client-text-field-label "
                    errMessage={formErrors[formField.name] || ""}
                    rightElement={formField.rightText}
                    inputCover={formField.cls ? "custom-cover-w" : ""}
                    onChange={
                      formField.onChange || setFormFieldData(formField.name)
                    }
                    value={formData[formField.name]}
                    isRequired={formField.required}
                    disabled={formField.disabled}
                  />
                )}
                {formField.type === FIELD_TYPE.AUTOCOMPLETE && (
                  <AutoComplete
                    options={
                      formField.options || [
                        { label: "bhopal", value: "bhopal" },
                      ]
                    }
                    label={formField.label}
                    autoCompleteClassName={"edit-client-autocomplete"}
                    className={"edit-client-autocomplete-field"}
                    labelClassName={"edit-client-autocomplete-field-label"}
                    placeholder={formField.placeholder}
                    errMessage={formErrors[formField.name] || ""}
                    inputName={formField.name}
                    onChange={
                      formField.onChange || setFormFieldData(formField.name)
                    }
                    inputCover={formField.cls ? "custom-cover-w" : ""}
                    value={formField.name === "st" ? handleFetchCities(formField.name) : formData[formField.name]}
                    isRequired={formField.required}
                    disabled={formField.disabled}
                  />
                )}
                {formField.type === FIELD_TYPE.DATEPICKER && (
                  <DatePickerInput
                    inputName={formField.name || ""}
                    className="edit-client-datepicker-field"
                    label={formField.label}
                    labelClassName="edit-client-datepicker-field-label"
                    DatepickerClassName="edit-client-datepicker"
                    errMessage={formErrors[formField.name] || ""}
                    inputCover={formField.cls ? "custom-cover-w" : ""}
                    onChange={
                      formField.onChange || setFormFieldData(formField.name)
                    }
                    value={formData[formField.name]}
                    isRequired={formField.required}
                  />
                )}
                {
                  formField.type === FIELD_TYPE.CHECKBOX && <div className={`edit-client-lc-cnt ${formField.cls}`}><input type='checkbox' checked={tnc ? formData[formField.name] : formData[formField.name].includes(LIVE_TRACKING_ACC_CODE)} onChange={formField.onChange} name={formField.name} className="edit-client-checkbox"/><label className="edit-client-label">{formField.label}</label></div>
                }
              </div>
            );
          })}
          <div className="add-battery-submit-button">
            <Button className={`add-battery-button ${tnc && !editedValues.agTnc ? "disabled-btn" : ""}`} onClick={submitHandler}>
              Save
            </Button>
          </div>
        </form>
      </div>

      <SuccessPopupModal {...successModalProps} />
    </section>
  );
};

export default EditDealership;
